import { render, staticRenderFns } from "./BaseBackButton.vue?vue&type=template&id=6be09e3a&scoped=true"
import script from "./BaseBackButton.vue?vue&type=script&lang=js"
export * from "./BaseBackButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be09e3a",
  null
  
)

export default component.exports